var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.fullPath === '/'),expression:"$route.fullPath === '/'"}],staticClass:"absolute block md:hidden w-20 h-10 top-0 right-4",style:({
                    backgroundImage: 'url(fr/images/summary/summary-logo.png)'
                 })})}
var staticRenderFns = []

export { render, staticRenderFns }